import { Logotype, breakpoints, pxToRem, Sidebar, themeGet, ListItem } from '@pocketlaw/tetris';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
export const StyledLogoType = styled(Logotype) `
  height: ${pxToRem(20)};
  width: auto;
`;
export const AlignRight = styled.span `
  display: flex;
  margin-left: auto;
`;
export const StyledMobileSidebar = styled(Sidebar) `
  box-shadow: ${themeGet('dropShadow.400')};
  width: ${pxToRem(360)};
`;
export const StyledDesktopSidebar = styled(Sidebar) `
  display: none;

  ${breakpoints.md} {
    display: flex;
  }
`;
export const StyledListItem = styled(ListItem) `
  text-decoration: none;
`;
export const StyledLink = styled(Link) `
  display: flex;
`;
export const SearchPopupLauncherContainer = styled.div `
  padding: ${themeGet('spacing.lg')} ${themeGet('spacing.md')};
`;
export const LauncherButtonContent = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  gap: ${themeGet('spacing.md')};
  width: 100%;
`;
